import { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

export const UserPreferencesContext = createContext();

// Create a context provider component
export const UserPreferencesProvider = ({ children }) => {
  // initial state and required variables for rendering
  const [userPreferences, setContextUserPreferences] = useState({
    // main app hide/show of the sidebar
    hideSidebar: false,
  });

  useEffect(() => {
    const storedPreferences = localStorage.getItem('sb-userpreferences');
    if (storedPreferences) {
      const parsedPreferences = JSON.parse(storedPreferences);
      const updatedPreferences = {
        ...userPreferences,
        ...parsedPreferences,
      };
      setUserPreferences(updatedPreferences);
    }
  }, []);

  const setUserPreferences = (newPreferences) => {
    // special context exposed func for setting user preferences
    //
    // sets the context used in the app, but also saves updated
    // preferences to localStorage
    const allPreferences = {
      ...userPreferences,
      ...newPreferences,
    };
    // set preferences to the context
    setContextUserPreferences(allPreferences);
    // set preferences to localStorage
    localStorage.setItem('sb-userpreferences', JSON.stringify(allPreferences));
  };

  return (
    <UserPreferencesContext.Provider
      value={[userPreferences, setUserPreferences]}
    >
      {children}
    </UserPreferencesContext.Provider>
  );
};
